module.exports = __webpack_public_path__ + "ec4d7ae6a7f5007000fc219887443038.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/geshui_logo.png
 ** module id = 1114
 ** module chunks = 1
 **/